import React, { useEffect, useRef, useState } from "react";
import { CasinoIconGameType } from "../../common/types/Casino/CasinoIconGameType";
import { GameProviderRequest } from "../../common/types/Casino/GameProvider";
import { Carusel } from "../../components/carusel/Carusel";
import { CasinoList } from "../../components/casinoList/CasinoList";
import { Layout } from "../../components/layout";
import { LiveCasinoProviders } from "../../components/livecasino/LiveCasinoProviders/LiveCasinoProviders";
import { LiveCasinoSearch } from "../../components/livecasino/LiveCasinoSearch/LiveCasinoSearch";
import { CasinoInfo } from "../../services";
import { mockCouruselLive } from "./mockCourusel/mockCouruselLive";

import "./LiveCasino.scss";
import { useTypeSelector } from "../../hooks/useTypeSelector";
import { BananersEnum } from "../../common/types/Banners/BannersList";
import { SelectProvider } from "srcm/components/casino/selectProvider/SelectProvider";
import { SelectProviderPopap } from "srcm/components/casino/selectProviderPopap/SelectProviderPopap";

const LiveCasino = () => {
  const [load, setLoad] = useState(true);

  const [providerPopapOpen, setProviderPopapOpen] = useState(false);
  const [showByParams, setShowByParams] = useState(false);

  const [providersList, setProvidersList] = useState<GameProviderRequest>();
  const [selectedProviders, setSelectedProviders] = useState<number[]>([]);
  const [selectedProvidersUrl, setSelectedProvidersUrl] = useState("");

  const [loadingGamesAdd, setLoadingGamesAdd] = useState(false);
  const [loadStop, setLoadStop] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(true);

  const [casinoGames, setCasinoGames] = useState<CasinoIconGameType[]>([]);
  const [checkedGame, setCheckedGame] = useState(-1);
  const page = useRef(1);

  const [seacrhGames, setSeacrhGames] = useState("");
  const [filteredData, setFilteredData] = useState(providersList);
  const [searchInput, setSearchInput] = useState("");

  const bannersList = useTypeSelector(
    (data) => data.accountInfoReducer.banners
  );

  useEffect(() => {
    setTimeout(() => {
      setLoad(false);
    }, 1000);
  }, []);

  const filterData = (searchQuery: string) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const filtered = Object.keys(providersList)
      .filter((provider) =>
        provider.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .reduce((filteredObj, key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        filteredObj[key] = providersList[key];
        return filteredObj;
      }, {});
    setFilteredData(filtered);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearchInput(input);

    if (input === "") {
      setFilteredData(providersList); // Если input пустой, показываем все данные
    } else {
      filterData(input);
      setSelectedProviders([]);
    }
  };

  useEffect(() => {
    async function getProvidersList() {
      const res = await CasinoInfo.providers(
        "?type=live-casino&is_mobile=true"
      );
      setProvidersList(res.data);
    }

    try {
      page.current = 1;
      getProvidersList();
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    if (selectedProviders.length > 0) {
      let timeUrl = "";
      selectedProviders.map((item: number) => {
        timeUrl = timeUrl + item + ",";
      });
      setSelectedProvidersUrl(timeUrl);
    } else {
      setSelectedProvidersUrl("");
    }
  }, [selectedProviders]);

  useEffect(() => {
    page.current = 1;
    setLoadStop(false);
    async function casinoGames() {
      // setLoadingAdd(true);
      const res = await CasinoInfo.games(
        `/live?current_page=1&limit=35&page=${page.current}&is_mobile=true${
          selectedProvidersUrl.length > 0
            ? `providers_ids[]=${selectedProvidersUrl}`
            : ""
        }`
      );
      setCasinoGames(res.data);
      setLoadingAdd(false);
    }
    async function casinoGamesSearch() {
      setLoadingGamesAdd(true);
      const res = await CasinoInfo.searchGames(
        `?current_page=1&limit=35&page=${page.current}&search=${seacrhGames}&is_mobile=1&is_desktop=0`
      );
      setCasinoGames(res.data);
      setLoadingGamesAdd(false);
      if (res.data.data.length === 0) {
        setLoadStop(true);
      } else {
        setLoadStop(false);
      }
      setLoadingAdd(false);
    }
    if (seacrhGames.length === 0) {
      casinoGames();
    } else {
      casinoGamesSearch();
    }
  }, [selectedProviders, selectedProvidersUrl, seacrhGames]);

  async function loadMoreItem() {
    async function casinoGames() {
      if (!loadStop) {
        page.current++;
        setLoadingGamesAdd(true);
        const res = await CasinoInfo.games(
          `/live?current_page=1&limit=35&page=${page.current}&is_mobile=1&${
            selectedProvidersUrl.length > 0
              ? `providers_ids[]=${selectedProvidersUrl}`
              : ""
          }`
        );
        setCasinoGames((prevState) => prevState.concat(res.data));
        if (res.data.length === 0) {
          setLoadStop(true);
        } else {
          setLoadStop(false);
        }
        setLoadingGamesAdd(false);
        setLoadingAdd(false);
      }
    }
    async function casinoGamesSearch() {
      page.current++;
      setLoadingGamesAdd(true);
      const res = await CasinoInfo.searchGames(
        `?current_page=1&limit=35&page=${page.current}&search=${seacrhGames}&is_mobile=1&`
      );
      setCasinoGames((prevState) => prevState.concat(res.data));
      setLoadingGamesAdd(false);
      if (res.data.data === 0) {
        setLoadStop(true);
      } else {
        setLoadStop(false);
      }
      setLoadingGamesAdd(false);
      setLoadingAdd(false);
    }
    if (seacrhGames.length === 0) {
      if (!loadStop) {
        casinoGames();
      }
    } else {
      if (!loadStop) {
        casinoGamesSearch();
      }
    }
  }
  return (
    <Layout
      containerStyles="is-home-page casino-slots compact-footer "
      navHeader="livecasino"
      loadStop={loadStop}
      footerNav="liveCasino"
      footerNavType="casino"
    >
      <div className="layout-content-holder-bc">
        {load ? null : (
          <Carusel
            mockCarusel={bannersList}
            filtredSelect={BananersEnum.LiveCasino}
          />
        )}
        {/* <LiveCasinoProviders
          selectedProviders={selectedProviders}
          setSelectedProviders={setSelectedProviders}
          providersList={providersList}
        /> */}
        {/* <LiveCasinoSearch
          setSeacrhGames={setSeacrhGames}
          seacrhGames={seacrhGames}
        /> */}
        <SelectProvider
          setProviderPopapOpen={setProviderPopapOpen}
          setShowByParams={setShowByParams}
          showByParams={showByParams}
          selectedProviders={selectedProviders}
          seacrhGames={seacrhGames}
          setSeacrhGames={setSeacrhGames}
        />
        {providerPopapOpen ? (
          <SelectProviderPopap
            setProviderPopapOpen={setProviderPopapOpen}
            providersList={providersList}
            setSelectedProviders={setSelectedProviders}
            selectedProviders={selectedProviders}
            setShowByParams={setShowByParams}
            searchInput={searchInput}
            handleSearchChange={handleSearchChange}
            filteredData={filteredData}
          />
        ) : null}
        <CasinoList
          loadingAdd={loadingAdd}
          casinoGames={casinoGames}
          checkedGame={checkedGame}
          setCheckedGame={setCheckedGame}
          loadMoreItem={loadMoreItem}
          loadingGamesAdd={loadingGamesAdd}
          liveCasino={true}
        />
      </div>
    </Layout>
  );
};

export { LiveCasino };
